import styled from "styled-components";
import React from "react";
import { Edit } from "../../assets/Menu/Edit";
import { Link } from "react-router-dom";
import { UserProfile } from "../../assets/User/UserProfile";
import PersonalDataShow from "../../components/forms/PersonalDataShow";
import PersonalDataEdit from "../../components/forms/PersonalDataEdit";

const StyleCss = styled.div`
  
`;

function PersonalData(props) {
  let edit = '';
  if(!(props.match.params.edit === 'edit')){
    edit = (
      <Link to={'/work/personal-data/edit'} className="action"><Edit/></Link>
    )
  }


  // default form
  let data = (
    <PersonalDataShow {...props}/>
  )

  if(props.match.params.edit === 'edit'){
    // host edit
    data = (
      <PersonalDataEdit {...props}/>
    )
  }



  return (
    <StyleCss className="main-box">
      <div className="title-bar">
          <div className="title">
            <div className="icon"><UserProfile/></div>
            <div className="text">Personal Data</div>
          </div>
          {edit}
      </div>
      <div className="content">
        {data}
      </div>
    </StyleCss>
);
}
export default PersonalData;